<template>
    <div v-if="hasLoadedBase" class="mb-5 pb-5">
        <div class="text-center md:text-left">
            <div class="mt-5 flex flex-col md:flex-row justify-arrow">
                <div class="flex flex-col items-center md:items-start w-full">
                    <h1 class="text-3xl text-center md:text-left">
                        Detalles de {{ orderMessage }}
                        <strong class="text-theme-primary">
                            #{{ orderComponent.id }}
                        </strong>
                    </h1>
                    <strong v-show="orderComponent.uuid">
                        Código {{ orderComponent.uuid }}
                    </strong>
                </div>

                <div
                    class="flex flex-col mt-2 md:mt-0 md:min-w-max justify-center text-center"
                >
                    <small> 📆💾 {{ orderComponent.createdAt | date }} </small>
                    <small> 📆✏ {{ orderComponent.updatedAt | date }} </small>
                    <small v-if="orderComponent.deletedAt">
                        📆🗑️ {{ orderComponent.deletedAt | date }}
                    </small>
                </div>
                <div class="flex items-center justify-center mt-3 md:mt-0">
                    <div>
                        <app-button
                            icon
                            circle
                            color="brand-purple"
                            @click="getBaseItem"
                        >
                            <reload-icon class="text-white h-5 w-5" />
                        </app-button>
                    </div>
                </div>
            </div>

            <div
                class="flex items-center justify-center md:justify-end gap-2"
            ></div>
        </div>

        <div class="my-3 flex">
            <custom-navbar
                id="tabs-order"
                v-model="activeTab"
                center-collapsed
                not-line
            >
                <template #left>
                    <custom-navbar-item id="home">
                        <router-link
                            :to="homeUrl"
                            class="rounded-full bg-brand-blue flex justify-center items-center p-2"
                        >
                            <span>🏠</span>
                        </router-link>
                    </custom-navbar-item>
                    <custom-navbar-item
                        v-if="id"
                        id="delivery"
                        :active="activeTab === 'delivery'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> Entrega </span>
                            <span>&nbsp;🚚</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        v-if="id && !isQuote"
                        id="payment"
                        :active="activeTab === 'payment'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> Pago </span>
                            <span>&nbsp;💳</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        id="customer"
                        :active="activeTab === 'customer'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> Cliente </span>
                            <span>&nbsp;👩‍🦱</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        v-if="$ability.hasPermission('order:Assign')"
                        id="provider"
                        :active="activeTab === 'provider'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> Tienda </span>
                            <span>&nbsp;🏪</span>
                        </div>
                    </custom-navbar-item>
                    <custom-navbar-item
                        v-if="id"
                        id="products"
                        :active="activeTab === 'products'"
                        class="px-2 md:px-4 xl:px-6"
                    >
                        <div class="flex">
                            <span class="lg:block hidden"> Productos </span>
                            <span>&nbsp;🛍️</span>
                        </div>
                    </custom-navbar-item>
                </template>
                <template #right>
                    <div class="hidden md:block mr-2">
                        <custom-switch
                            v-if="$ability.hasPermission('order:Update') && id"
                            v-model="enabledUpdate"
                        >
                            <span class="text-theme-inverse">🖊</span>
                        </custom-switch>
                    </div>
                    <dropdown-popover class="mr-2" shadow border-thick>
                        <custom-avatar
                            pointer
                            size="large"
                            circle
                            class="bg-theme-primary text-theme-inverse"
                        >
                            <span> ⚙ </span>
                        </custom-avatar>
                        <template #tooltip>
                            <div class="flex flex-col text-left w-full">
                                <div>
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-stack-primary hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Vale de orden"
                                        @click="isOpenModalVoucher = true"
                                    >
                                        🖨&nbsp;Vale de orden
                                    </button>
                                </div>
                                <div>
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-indigo-700 hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Vale de orden"
                                        @click="generateOrderComponentPDF"
                                    >
                                        📕&nbsp;Comprobante
                                    </button>
                                </div>
                                <div v-if="orderComponent.location">
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-stack-secondary hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Guía de entrega"
                                        @click="isOpenModalDeliveryNote = true"
                                    >
                                        🚚&nbsp;Guía de entrega
                                    </button>
                                </div>
                                <div v-if="isHomeDelivery">
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-stack-primary hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Hoja de envío"
                                        @click="isOpenModalShippingLabel = true"
                                    >
                                        📦&nbsp;Hoja de envío
                                    </button>
                                </div>

                                <div
                                    v-if="
                                        !!$data.$nextOrderStatuses[
                                            orderComponent.deliveryStatus
                                        ] &&
                                        (isMerchantOrder
                                            ? $ability.hasPermission(
                                                  'order:UpdateOwn'
                                              )
                                            : $ability.hasPermission(
                                                  'order:Update'
                                              ))
                                    "
                                >
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-primary hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Siguiente estado"
                                        @click="nextOrderStatusesOrderComponent"
                                    >
                                        ⏩&nbsp;Siguiente estado
                                    </button>
                                </div>

                                <div
                                    v-if="
                                        ![
                                            $data.$ordersStatuses.completed,
                                            $data.$ordersStatuses.cancelled,
                                            $data.$ordersStatuses.quote,
                                            $data.$ordersStatuses.returned,
                                            $data.$ordersStatuses.wildcard
                                        ].includes(
                                            orderComponent.deliveryStatus
                                        ) &&
                                        (isMerchantOrder
                                            ? $ability.hasPermission(
                                                  'order:CompleteOwn'
                                              )
                                            : $ability.hasPermission(
                                                  'order:Complete'
                                              ))
                                    "
                                >
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-success hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Completar"
                                        @click="completeOrderComponent"
                                    >
                                        🏁&nbsp;Completar
                                    </button>
                                </div>

                                <div
                                    v-if="
                                        $ability.hasPermission(
                                            'order:Assign'
                                        ) &&
                                        !isMerchantOrder &&
                                        !orderComponent.supplyMerchant
                                    "
                                >
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-stack-primary hover:text-white text-theme-base px-2 py-3 rounded-lg flex items-center"
                                        aria-label="Asignar a tienda"
                                        @click="assignOrderComponent"
                                    >
                                        🚚&nbsp;Asignar a
                                        {{
                                            selectedMerchant.merchantType
                                                | merchantInfo("type")
                                        }}
                                        {{ selectedMerchant.name }}
                                    </button>
                                </div>

                                <div
                                    v-if="
                                        $ability.hasPermission(
                                            'order:Update'
                                        ) && !orderComponent.customer
                                    "
                                >
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-hover p-3 rounded-lg flex items-center"
                                        aria-label="Asignar a cliente"
                                        @click="openAssignCustomer"
                                    >
                                        👩&nbsp;Asignar cliente
                                    </button>
                                </div>

                                <div
                                    v-if="
                                        $ability.hasPermission(
                                            'order:Consultancy'
                                        ) &&
                                        !isMerchantOrder &&
                                        !orderComponent.supplyMerchant
                                    "
                                >
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-brand-purple hover:text-white p-3 rounded-lg flex items-center"
                                        aria-label="Dividir y asignar proveedores"
                                        @click="goToRefactor"
                                    >
                                        🚚&nbsp;Dividir y asignar proveedores
                                    </button>
                                </div>

                                <div
                                    v-if="
                                        $ability.hasPermission('order:Delete')
                                    "
                                >
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-danger hover:text-white active:bg-theme-danger p-3 text-theme-base rounded-lg flex items-center"
                                        aria-label="Eliminar orden"
                                        @click="deleteOrderComponent"
                                    >
                                        🗑️&nbsp;Eliminar orden
                                    </button>
                                </div>

                                <div v-if="canSeeOrderHistory">
                                    <button
                                        class="w-full text-left md:m-1 m-0.5 cursor-pointer transition-all duration-300 hover:bg-theme-primary hover:text-white text-theme-base p-3 rounded-lg flex items-center"
                                        aria-label="Historial"
                                        @click="isOpenModalHistory = true"
                                    >
                                        🕑&nbsp;Historial
                                    </button>
                                </div>
                            </div>
                        </template>
                    </dropdown-popover>
                </template>
            </custom-navbar>
        </div>

        <div
            v-if="$ability.hasPermission('order:Update') && id"
            class="flex justify-center"
        >
            <div class="block md:hidden my-3">
                <custom-switch v-model="enabledUpdate">
                    <span class="text-theme-inverse">🖊</span>
                </custom-switch>
            </div>
        </div>

        <div v-show="['delivery', 'home'].includes(activeTab)">
            <h2 class="text-theme-primary text-2xl">Detalles de entrega 🚚</h2>
            <div class="flex flex-wrap mt-4">
                <div class="w-full flex flex-col">
                    <strong>Bitacora </strong>
                    <textarea
                        v-model="orderComponent.observation"
                        :disabled="!enabledUpdate"
                        class="app-textarea text-theme-base mx-2 my-2"
                        placeholder="Comentarios"
                        rows="5"
                        @blur="changeValidators.observation = true"
                    ></textarea>
                </div>
                <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong>Fecha de pedido </strong>
                    <span class="mt-2 ml-2">
                        {{ orderComponent.createdAt | date }}
                    </span>
                </div>
                <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong>Fecha de última actualización </strong>
                    <span class="mt-2 ml-2">
                        {{ orderComponent.updatedAt | date }}
                    </span>
                    <span v-if="orderComponent.deletedAt">
                        {{ orderComponent.deletedAt | date }}
                    </span>
                </div>

                <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong>Fecha entrega </strong>

                    <date-picker
                        v-if="enabledUpdate"
                        v-model="orderComponent.deliveryAt"
                        locale="es"
                        size="sm"
                        :min="$data.$minDeliveryDate"
                        @input="changeValidators.deliveryAt = true"
                    />
                    <span v-else class="mt-2 ml-2">
                        {{
                            orderComponent.deliveryAt
                                | dateSimple(changeValidators.deliveryAt)
                        }}
                    </span>
                </div>

                <div class="w-full md:w-1/2 mt-4 flex flex-col">
                    <delivery-option-selector
                        v-model="orderComponent.deliveryOption"
                        :enabled="enabledUpdate && isPortalOrder"
                        @change="changeValidators.deliveryOption = true"
                    />
                </div>

                <div
                    v-if="orderComponent.location"
                    class="w-full flex flex-wrap"
                >
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Nombre de la persona que recibe </strong>
                        <span class="mt-2 ml-2">
                            {{
                                orderComponent.location.receiverName ||
                                "No definido"
                            }}
                        </span>
                    </div>
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Celular persona que recibe </strong>
                        <span class="mt-2 ml-2">
                            {{
                                orderComponent.location.receiverPhone ||
                                "No definido"
                            }}
                        </span>
                    </div>
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Ciudad </strong>
                        <span class="mt-2 ml-2">
                            {{ orderComponent.location.city }}
                        </span>
                    </div>
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Dirección </strong>
                        <span class="mt-2 ml-2">
                            {{ orderComponent.location.address }}
                            {{ orderComponent.location.addressComplement }} /
                            Barrio
                            {{ orderComponent.location.neighborhood }}
                        </span>
                    </div>
                </div>

                <div class="w-full md:w-1/2 mt-4 px-2">
                    <delivery-status-selector
                        v-model="orderComponent.deliveryStatus"
                        :enabled="enabledUpdate"
                        @change="changeValidators.deliveryStatus = true"
                    />
                </div>

                <div
                    v-if="orderComponent.pickupMerchant"
                    class="w-full md:w-1/2 px-2 mt-4 flex flex-col"
                >
                    <strong>Punto de Entrega </strong>

                    <div
                        v-if="orderComponent.pickupMerchant"
                        class="flex justify-between"
                    >
                        <span class="mt-2 ml-2 link-warning">
                            <a
                                :href="`/app/${orderComponent.pickupMerchant.merchantType}s/detail/${orderComponent.pickupMerchant.merchantId}`"
                                target="_blank"
                                rel="noopener"
                            >
                                {{ orderComponent.pickupMerchant.name }}
                            </a>
                        </span>
                        <dropdown-popover v-model="activePickupTooltip">
                            <button
                                type="button"
                                class="text-lg rounded-full h-5 w-5 bg-theme-primary text-white border border-theme-primary flex items-center justify-center"
                            >
                                ℹ
                            </button>
                            <template #tooltip>
                                <merchant-info-card
                                    :merchant="orderComponent.pickupMerchant"
                                />
                            </template>
                        </dropdown-popover>
                    </div>
                </div>
            </div>
            <div
                v-if="enabledUpdate"
                class="flex flex-col sm:flex-row justify-center my-4"
            >
                <app-button
                    primary
                    class="w-full sm:w-auto"
                    @click="verifyUpdateOrderDeliveryInfo"
                >
                    Actualizar opciones de entrega
                </app-button>
                <app-button
                    v-if="
                        !!$data.$nextOrderStatuses[
                            orderComponent.deliveryStatus
                        ]
                    "
                    success
                    class="w-full sm:w-auto"
                    @click="nextOrderStatusesOrderComponent"
                >
                    Siguiente estado
                </app-button>
            </div>
        </div>

        <div v-if="activeTab === 'payment' && !isQuote">
            <h2 class="text-theme-primary text-2xl">Detalles de pago 💳</h2>
            <div class="flex flex-wrap mt-4">
                <div class="w-full px-2 mb-4">
                    <div
                        class="rounded-lg p-4 border-2 border-dashed border-theme-border"
                    >
                        <div class="space-y-3 pb-4">
                            <div
                                v-if="orderComponent.deliveryPrice > 0"
                                class="flex justify-between text-theme-base"
                            >
                                <span>Costo entrega:</span>
                                <span class="font-medium">
                                    {{
                                        orderComponent.deliveryPrice | currency
                                    }}
                                </span>
                            </div>

                            <div
                                v-if="orderComponent.paymentPrice > 0"
                                class="flex justify-between text-theme-base"
                            >
                                <span>Costo de pago:</span>
                                <span class="font-medium">
                                    {{ orderComponent.paymentPrice | currency }}
                                </span>
                            </div>

                            <div class="flex justify-between text-theme-base">
                                <span>Subtotal productos:</span>
                                <span class="font-medium">
                                    {{ productsSubtotal | currency }}
                                </span>
                            </div>

                            <div
                                v-if="orderComponent.totalDiscountApplied > 0"
                                class="flex justify-between text-theme-danger font-bold"
                            >
                                <span>Descuento aplicado:</span>
                                <span>
                                    -
                                    {{
                                        orderComponent.totalDiscountApplied
                                            | currency
                                    }}
                                </span>
                            </div>
                        </div>

                        <div class="py-3 border-t border-b border-theme-border">
                            <div
                                class="flex justify-between text-lg font-semibold text-theme-primary"
                            >
                                <span>Total:</span>
                                <span>
                                    {{ orderComponent.total | currency }}
                                </span>
                            </div>
                        </div>

                        <div class="pt-3 space-y-3">
                            <div
                                class="flex justify-between text-theme-success font-semibold"
                            >
                                <span>Monto Pagado (Abono):</span>
                                <span>{{
                                    orderComponent.valuePaid | currency
                                }}</span>
                            </div>

                            <div
                                class="flex justify-between text-lg font-semibold p-3 border-2 rounded-lg mt-2"
                                :class="
                                    orderComponent.total -
                                        orderComponent.valuePaid >
                                    0
                                        ? 'border-theme-danger text-theme-danger'
                                        : 'border-theme-success text-theme-success'
                                "
                            >
                                <span>Saldo Pendiente:</span>
                                <span>{{
                                    (orderComponent.total -
                                        orderComponent.valuePaid)
                                        | currency
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full px-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                    <payment-method-selector
                        v-model="orderComponent.paymentMethod"
                        :enabled="enabledUpdate"
                        @change="changeValidators.paymentMethod = true"
                    />

                    <payment-status-selector
                        v-model="orderComponent.paymentStatus"
                        :enabled="enabledUpdate"
                        @change="changeValidators.paymentStatus = true"
                    />

                    <input-money-component
                        v-if="enabledUpdate"
                        v-model="orderComponent.valuePaid"
                        border
                        enabled
                        label="Abono"
                        icon="💲"
                        :message-error="
                            orderComponent.valuePaid > orderComponent.total
                                ? `El valor pagado debe ser menor a ${orderComponent.total}`
                                : ''
                        "
                        @blur="changeValidators.valuePaid = true"
                    />

                    <div v-else class="flex flex-col">
                        <strong>Abono </strong>
                        <span class="mt-2 ml-2">
                            {{ orderComponent.valuePaid | money }}
                        </span>
                    </div>

                    <input-money-component
                        v-if="enabledUpdate && canEditDeliveryPrice"
                        v-model="orderComponent.deliveryPrice"
                        border
                        enabled
                        label="Costo de envío"
                        icon="🚚"
                        @input="changeValidators.deliveryPrice = true"
                    />
                </div>
            </div>
            <div
                v-if="enabledUpdate"
                class="flex flex-wrap justify-center gap-2 my-4"
            >
                <app-button @click="updateOrderPaymentInfo">
                    Actualizar información pago
                </app-button>

                <app-button color="#d33ddd" @click="completeOrderPayment">
                    Marcar Pago como completado
                </app-button>
            </div>
        </div>

        <div v-if="activeTab === 'customer'">
            <h2 class="text-theme-primary text-2xl">Detalles de cliente 👩‍🦱</h2>
            <div class="flex flex-wrap mt-4">
                <fragment v-if="orderCustomer">
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Nombre de cliente </strong>
                        <div class="mt-2 ml-2 link-warning">
                            <a
                                v-if="
                                    orderCustomer.id &&
                                    $ability.hasPermission('customer:Get')
                                "
                                :href="`/app/customers/detail/${orderCustomer.id}`"
                                target="_blank"
                                rel="noopener"
                            >
                                {{
                                    `${orderCustomer.firstName} ${orderCustomer.lastName}`
                                }}
                            </a>
                            <span v-else>
                                {{
                                    `${orderCustomer.firstName} ${orderCustomer.lastName}`
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Identificación </strong>
                        <span
                            v-if="orderCustomerIdentification"
                            class="mt-2 ml-2"
                        >
                            {{ orderCustomerIdentification }}
                        </span>
                        <span v-else class="mt-2 ml-2 text-theme-muted">
                            {{ emptyIdentification }}
                        </span>
                    </div>
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Celular de contacto </strong>
                        <span class="mt-2 ml-2">
                            {{ orderCustomer.phone }}
                        </span>
                    </div>
                    <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                        <strong>Correo electrónico </strong>
                        <span v-if="orderCustomer.email" class="mt-2 ml-2">
                            {{ orderCustomer.email }}
                        </span>
                        <span v-else class="mt-2 ml-2 text-theme-muted">
                            {{ emptyEmail }}
                        </span>
                    </div>
                </fragment>
                <div v-else class="w-full flex justify-center flex-col">
                    <span class="mr-2 mt-4 text-2xl">
                        No se ha asignado a cliente
                    </span>
                    <div class="flex justify-center">
                        <app-button
                            v-if="enabledUpdate"
                            @click="openAssignCustomer"
                        >
                            Asignar cliente
                        </app-button>
                    </div>
                </div>
                <div class="w-full px-2 mt-4 flex flex-col">
                    <strong class="text-theme-muted text-sm">
                        Comentario para el cliente
                    </strong>
                    <textarea
                        v-model="orderComponent.customerNote"
                        :disabled="!enabledUpdate"
                        class="app-textarea text-theme-base mx-2 my-2"
                        placeholder="Este texto se imprime en el comprobante del cliente"
                        rows="3"
                        @blur="changeValidators.customerNote = true"
                    ></textarea>
                </div>
            </div>
        </div>

        <div v-if="activeTab === 'provider'">
            <h2 class="text-theme-primary text-2xl">Gestión de tienda 🏪</h2>
            <div class="flex flex-wrap mt-4">
                <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong> Origen del Stock </strong>
                    <div
                        v-if="orderComponent.supplyMerchant"
                        class="flex justify-between"
                    >
                        <span class="mt-2 ml-2 link-warning">
                            <a
                                :href="`/app/${orderComponent.supplyMerchant.merchantType}s/detail/${orderComponent.supplyMerchant.merchantId}`"
                                target="_blank"
                                rel="noopener"
                                class="capitalize"
                            >
                                {{
                                    orderComponent.supplyMerchant.merchantType
                                        | merchantInfo("type")
                                }}
                                {{ orderComponent.supplyMerchant.name }}
                            </a>
                        </span>
                        <dropdown-popover v-model="activeSupplyTooltip">
                            <button
                                type="button"
                                class="text-lg rounded-full h-5 w-5 bg-theme-primary text-white border border-theme-primary flex items-center justify-center"
                            >
                                ℹ
                            </button>
                            <template #tooltip>
                                <merchant-info-card
                                    :merchant="orderComponent.supplyMerchant"
                                />
                            </template>
                        </dropdown-popover>
                    </div>

                    <span v-else class="mt-2 ml-2 text-theme-warning">
                        Por definir
                    </span>
                </div>

                <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong>Vendedor </strong>
                    <div
                        v-if="orderComponent.seller"
                        class="mt-2 ml-2 link-warning"
                    >
                        <a
                            v-if="$ability.hasPermission('user:Get')"
                            :href="`/app/users/detail/${orderComponent.seller.id}`"
                            target="_blank"
                            rel="noopener"
                        >
                            {{ orderComponent.seller.email }}
                        </a>
                        <span v-else>
                            {{ orderComponent.seller.email }}
                        </span>
                    </div>
                    <span v-else class="mt-2 ml-2"> Web </span>
                </div>
                <div class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong>Origen </strong>
                    <span class="mt-2 ml-2 capitalize">
                        {{ orderComponent.origin }}
                    </span>
                </div>
                <div
                    v-if="affectsInventory"
                    class="w-full md:w-1/2 px-2 mt-4 flex flex-col"
                >
                    <div class="flex justify-between items-center">
                        <strong>
                            {{
                                orderComponent.supplyMerchant
                                    ? "Decrementó inventario de tienda"
                                    : "Decrementó inventario"
                            }}
                        </strong>
                        <custom-tooltip border>
                            <button
                                type="button"
                                class="text-lg rounded-full h-5 w-5 bg-theme-primary text-white flex items-center justify-center"
                            >
                                ℹ
                            </button>
                            <template #tooltip>
                                <div class="flex flex-col gap-2 p-3 max-w-xs">
                                    <div
                                        class="space-y-2 text-xs text-theme-base"
                                    >
                                        <div class="flex gap-2">
                                            <span class="flex-shrink-0">•</span>
                                            <p class="text-left">
                                                Si no se ha restado inventario y
                                                marcas la casilla se restará
                                                inventario del tienda.
                                            </p>
                                        </div>
                                        <div class="flex gap-2">
                                            <span class="flex-shrink-0">•</span>
                                            <p class="text-left">
                                                En caso contrario si ya has
                                                restado inventario y desmarcas
                                                la casilla el inventario se
                                                regresará al sistema.
                                            </p>
                                        </div>
                                        <div class="flex gap-2">
                                            <span class="flex-shrink-0">•</span>
                                            <p class="text-left">
                                                De forma automática se restará
                                                inventario (en caso de que
                                                exista) en el cambio de estado
                                                de entrega a completado.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </custom-tooltip>
                    </div>

                    <div class="ml-2 mt-1">
                        <custom-checkbox
                            v-if="enabledUpdate"
                            v-model="orderComponent.stockDecremented"
                            warn
                            @click="changeValidators.stockDecremented = true"
                        >
                            <span>
                                {{
                                    orderComponent.stockDecremented
                                        ? "Si"
                                        : "No"
                                }}
                            </span>
                        </custom-checkbox>

                        <span v-else>
                            {{ orderComponent.stockDecremented ? "Si" : "No" }}
                        </span>
                    </div>
                </div>
                <div v-else class="w-full md:w-1/2 px-2 mt-4 flex flex-col">
                    <strong>Inventario</strong>
                    <span class="mt-2 ml-2 text-theme-muted">
                        {{ noInventoryReason }}
                    </span>
                </div>
                <div
                    v-if="stockReturnManual"
                    class="w-full px-2 mt-4 flex flex-col"
                >
                    <p
                        class="rounded-lg bg-theme-warning px-3 py-2 text-sm text-theme-inverse"
                    >
                        Las unidades de esta orden se descontaron de
                        {{ stockReturnSourceLabel }}, con un modo de inventario
                        distinto al que usas ahora. Si la cancelas, no se
                        devuelven solas: ajústalas a mano en tu inventario.
                    </p>
                </div>
                <div
                    v-if="orderComponent.orderGroupId"
                    class="w-full md:w-1/2 px-2 mt-4 flex flex-col link-warning"
                >
                    <a
                        :href="`/app/orders-groups/detail/${orderComponent.orderGroupId}`"
                        target="_blank"
                        rel="noopener"
                    >
                        Orden padre #{{ orderComponent.orderGroupId }}
                    </a>
                </div>
                <div
                    v-if="
                        !orderComponent.stockDecremented &&
                        !orderComponent.orderGroupId &&
                        enabledUpdate &&
                        $ability.hasPermission('order:Consultancy')
                    "
                    class="w-full md:w-1/2 px-2 mt-4 flex flex-col"
                >
                    <div>
                        <app-button @click="goToRefactor">
                            🚚 Dividir y asignar proveedores
                        </app-button>
                    </div>
                </div>
            </div>

            <div v-if="enabledUpdate" class="flex justify-center my-4">
                <app-button @click="updateMerchantInfo">
                    Actualizar información de proveedor
                </app-button>
            </div>
        </div>

        <div v-if="activeTab === 'products'">
            <div class="my-3 flex flex-wrap justify-between items-end gap-2">
                <h2 class="text-theme-primary text-2xl mt-4">
                    Detalles de productos 🪀
                </h2>
                <span class="text-lg">
                    Subtotal productos: {{ productsSubtotal | currency }}
                </span>
            </div>
            <div
                v-if="
                    orderComponent.anonymousReferences.length || enabledUpdate
                "
            >
                <div class="mt-3 flex justify-between items-center">
                    <h4 class="text-lg text-theme-primary">
                        Servicios / Productos libres
                    </h4>
                    <product-anonymous-button
                        v-if="enabledUpdate"
                        @input="addAnonymousReference"
                    />
                </div>
                <span
                    v-show="
                        enabledUpdate &&
                        orderComponent.anonymousReferences.length
                    "
                    class="my-3"
                >
                    Esta orden contiene servicios o productos sin registro
                    previo.
                </span>
                <order-reference-table-item
                    v-for="(
                        reference, index
                    ) in orderComponent.anonymousReferences"
                    :key="'B' + index"
                    :enabled="enabledUpdate"
                    :reference="reference"
                    class="w-full mx-auto"
                    @update="changeQuantityAnonymousReference"
                    @remove="removeAnonymousReference"
                    @focus="onFocusSomeInput"
                />
            </div>

            <h4 class="mt-3 text-lg text-theme-primary">Productos</h4>

            <span v-show="enabledUpdate" class="my-3">
                Puedes cambiar la cantidad de cada producto, agregar productos
                nuevos o quitar los que ya no van en la orden.
            </span>

            <references-search-scanner
                v-if="enabledUpdate"
                class="w-full mx-auto"
                :enabled-scanner="enabledScanner"
                @input="validatePushReferences"
            />

            <div v-if="orderComponent.references.length">
                <order-reference-table-item
                    v-for="(reference, index) in orderComponent.references"
                    :key="index"
                    :enabled="enabledUpdate"
                    :reference="reference"
                    :merchant="orderComponent.supplyMerchant"
                    enabled-discount
                    enabled-sale-price
                    :allow-above-catalog="isPortalOrder"
                    class="w-full mx-auto mt-2"
                    @update="changeQuantityReference"
                    @remove="removeReference"
                    @focus="onFocusSomeInput"
                />
            </div>
            <p v-else class="my-3 text-theme-muted">Sin productos.</p>

            <div v-if="enabledUpdate" class="flex justify-center my-4">
                <app-button
                    :disabled="hasSalePriceErrors"
                    @click="updateReferences"
                >
                    Actualizar productos
                </app-button>
            </div>
        </div>

        <app-dialog v-model="isOpenModalDeliveryNote">
            <template #header>
                <span class="text-lg">
                    Guia de Entrega
                    <span class="text-theme-primary">
                        # {{ orderComponent.id }}
                    </span>
                </span>
            </template>
            <delivery-note-printer
                show
                show-print
                :delivery-note="{
                    ...orderComponent.location,
                    ...orderComponent.customer,
                    uuid: orderComponent.uuid
                }"
            />
        </app-dialog>

        <app-dialog v-model="isOpenModalShippingLabel" size="lg">
            <template #header>
                <span class="text-lg">
                    Hoja de envío
                    <span class="text-theme-primary">
                        # {{ orderComponent.id }}
                    </span>
                </span>
            </template>
            <shipping-label-printer :order="orderComponent" />
        </app-dialog>

        <app-dialog v-model="isOpenModalVoucher" size="full">
            <template #header>
                <span class="text-xl">
                    Vale de Orden
                    <span class="text-theme-primary font-bold">
                        # {{ orderComponent.id }}
                    </span>
                </span>
            </template>
            <order-ticket-printer show show-print :order="orderComponent" />
        </app-dialog>

        <app-dialog
            v-model="isOpenModalSelectAddress"
            size="lg"
            @close="closeSelectAddressModal"
        >
            <template #header>
                <span class="text-lg"> Selecciona dirección de entrega </span>
            </template>
            <div
                v-if="isOpenModalSelectAddress && orderComponent.customer"
                class="flex flex-col gap-4 my-4"
            >
                <delivery-location-selector
                    :value="homeDeliveryLocation"
                    :customer-id="orderComponent.customer.id"
                    @input="onHomeDeliveryLocationChange"
                />
                <input-money-component
                    v-model="homeDeliveryPrice"
                    border
                    enabled
                    label="Costo de envío"
                    icon="🚚"
                />
                <div class="flex justify-center">
                    <app-button
                        :disabled="!homeDeliveryLocation"
                        @click="saveHomeDelivery"
                    >
                        Guardar domicilio
                    </app-button>
                </div>
            </div>
        </app-dialog>

        <app-dialog v-model="isOpenModalCustomers" size="lg">
            <template #header>
                <h3 class="text-3xl">Buscador de Clientes 👩‍🎤</h3>
            </template>

            <search-user is-customer @change="updateOrderCustomer" />
        </app-dialog>

        <order-history-dialog
            v-if="canSeeOrderHistory"
            v-model="isOpenModalHistory"
            :metadata="orderComponent.metadata"
            :order-id="orderComponent.id"
        />
    </div>
</template>

<script>
import tabQuerySyncMixin from "@/mixins/tabQuerySyncMixin";
import { DateTime } from "luxon";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

import { STATIC_ORDER_LOGO_PATH } from "@/common/constants";
import {
    INVENTORY_MODES,
    isStockReturnManual,
    resolveStockDecrementedFrom,
    stockSourceLabel
} from "@/common/fields/inventory-modes";
import { paymentMethodsCodes } from "@/common/fields/orders-payment-methods";
import { paymentStatuses } from "@/common/fields/orders-payment-status-codes";
import {
    nextOrderStatuses,
    ordersStatuses,
    ordersStatusesCodes
} from "@/common/fields/orders-status-codes";
import { dateFilter } from "@/common/lib/filters";
import { verifyImageLoads } from "@/common/lib/images";
import {
    CUSTOMER_EMPTY_EMAIL,
    CUSTOMER_EMPTY_IDENTIFICATION,
    formatCustomerIdentification,
    resolveOrderCustomer
} from "@/common/lib/order-customer";
import {
    getWebhookConfirmationDate,
    isPaymentConfirmedByWebhook
} from "@/common/lib/order-history";
import {
    resolveLineSalePrice,
    validateLineSalePrice
} from "@/common/lib/order-line-price";
import { generateOrderPDF } from "@/common/lib/pdf";
import { validateConfirmationMessage } from "@/common/lib/transformers";

import ReloadIcon from "@/components/icons/ReloadIcon.vue";
import DeliveryLocationSelector from "@/components/orders/DeliveryLocationSelector.vue";
import DeliveryOptionSelector from "@/components/orders/DeliveryOptionSelector.vue";
import DeliveryStatusSelector from "@/components/orders/DeliveryStatusSelector.vue";
import MerchantInfoCard from "@/components/orders/MerchantInfoCard.vue";
import OrderHistoryDialog from "@/components/orders/OrderHistoryDialog.vue";
import OrderReferenceTableItem from "@/components/orders/OrderReferenceTableItem.vue";
import OrderTicketPrinter from "@/components/orders/OrderTicketPrinter.vue";
import PaymentMethodSelector from "@/components/orders/PaymentMethodSelector.vue";
import PaymentStatusSelector from "@/components/orders/PaymentStatusSelector.vue";
import ShippingLabelPrinter from "@/components/orders/ShippingLabelPrinter.vue";
import ProductAnonymousButton from "@/components/products/ProductAnonymousButton.vue";
import ReferencesSearchScanner from "@/components/references/ReferencesSearchScanner.vue";
import SearchUser from "@/components/users/SearchUser.vue";
import AppDialog from "@/components/utils/AppDialog.vue";
import DatePicker from "@/components/utils/DatePicker.vue";
import DeliveryNotePrinter from "@/components/utils/DeliveryNotePrinter.vue";
import InputMoneyComponent from "@/components/utils/InputMoneyComponent.vue";

export default {
    name: "DetailOrder",
    components: {
        AppDialog,
        DatePicker,
        ReloadIcon,
        SearchUser,
        OrderTicketPrinter,
        OrderReferenceTableItem,
        InputMoneyComponent,
        DeliveryLocationSelector,
        MerchantInfoCard,
        PaymentMethodSelector,
        PaymentStatusSelector,
        ShippingLabelPrinter,
        DeliveryStatusSelector,
        DeliveryOptionSelector,
        ReferencesSearchScanner,
        DeliveryNotePrinter,
        ProductAnonymousButton,
        OrderHistoryDialog
    },
    mixins: [tabQuerySyncMixin],
    data: () => ({
        inventoryMode: null,
        orderComponent: {
            id: 4,
            orderGroupId: null,
            sellerId: 0,
            prepareTime: 3,
            prepareTimeRMS: 5,
            deliveryAt: "2022",
            observation: "Cargando...",
            customerNote: "",
            discounts: 0,
            total: 56000,
            valuePaid: 0,
            paymentStatus: "pending",
            paymentPrice: null,
            paymentMethod: "cash",
            paymentAt: null,
            deliveryStatus: "pending",
            deliveryOption: "home",
            deliveryPrice: 6000,
            referencesValueWithDiscount: 6000,
            totalDiscountApplied: 0,
            createdAt: "2022-01-28T17:11:50.406Z",
            updatedAt: "2022-01-28T17:11:50.406Z",
            supplyMerchant: {
                name: "",
                id: "",
                address: "Calle",
                type: "store",
                identificationNumber: ""
            },
            pickupMerchant: {
                name: "",
                id: "",
                address: "Calle",
                type: "store",
                identificationNumber: ""
            },
            seller: { email: "@gmail.com", id: "" },
            referencesSnapshot: [],
            anonymousReferences: [],
            references: [],
            customer: {
                id: 4,
                identificationType: "cc",
                identificationNumber: "Cargando...",
                firstName: "Usuario",
                lastName: "Cargando...",
                email: "Cargando...",
                phone: "Cargando..."
            },
            location: {
                id: 2,
                address: "Cargando...",
                addressComplement: "",
                cityCode: "11001",
                city: "Bogotá",
                neighborhood: "Cargando...",
                coordinates: { latitude: 4.63082, longitude: -74.15035 },
                receiverPhone: "Cargando ..",
                receiverName: "Cargando .."
            },
            type: "web",
            stockDecremented: false
        },
        isMerchantOrder: false,
        isOpenModalVoucher: false,
        isOpenModalDeliveryNote: false,
        isOpenModalShippingLabel: false,
        isOpenModalSelectAddress: false,
        homeDeliveryLocation: null,
        homeDeliveryPrice: 0,
        homeDeliverySaved: false,
        isOpenModalCustomers: false,
        isOpenModalHistory: false,
        savedPaymentStatus: null,
        savedDeliveryOption: null,
        isLoading: false,
        hasLoadedBase: false,
        showOptions: false,
        id: 0,
        enabledUpdate: false,
        activeTab: "delivery",
        $tabsWhitelist: [
            "delivery",
            "payment",
            "customer",
            "provider",
            "products"
        ],
        activeSupplyTooltip: false,
        activePickupTooltip: false,
        merchant: {
            merchantId: "",
            merchantType: ""
        },
        changeValidators: {
            observation: false,
            customerNote: false,
            valuePaid: false,
            paymentStatus: false,
            deliveryOption: false,
            deliveryStatus: false,
            paymentMethod: false,
            references: false,
            stockDecremented: false,
            anonymousReferences: false,
            deliveryAt: false,
            deliveryPrice: false
        },
        $minDeliveryDate: DateTime.now().toFormat("yyyy-MM-dd"),
        enabledScanner: false,
        $ordersStatuses: ordersStatuses,
        $nextOrderStatuses: nextOrderStatuses,
        homeUrl: "/app/orders"
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"]),
        ...mapState("orders", ["order"]),
        orderCustomer() {
            return resolveOrderCustomer(this.orderComponent);
        },
        orderCustomerIdentification() {
            return formatCustomerIdentification(this.orderCustomer);
        },
        emptyEmail() {
            return CUSTOMER_EMPTY_EMAIL;
        },
        emptyIdentification() {
            return CUSTOMER_EMPTY_IDENTIFICATION;
        },
        isHomeDelivery() {
            return (
                this.orderComponent.deliveryOption === "home" &&
                !!this.orderComponent.location
            );
        },
        // sucursales-inventario-multitenant: en modo global la orden
        // descuenta de la referencia sin tienda; sin modo leído se mantiene
        // el criterio de siempre (solo con tienda asignada).
        affectsInventory() {
            if (this.inventoryMode === INVENTORY_MODES.none) return false;
            if (this.inventoryMode === INVENTORY_MODES.global) return true;
            return Boolean(this.orderComponent.supplyMerchant);
        },
        noInventoryReason() {
            return this.inventoryMode === INVENTORY_MODES.none
                ? "No aplica — tu negocio no maneja inventario"
                : "No aplica — esta orden no está asociada a ninguna tienda";
        },
        stockReturnManual() {
            return isStockReturnManual(this.orderComponent, this.inventoryMode);
        },
        stockReturnSourceLabel() {
            return stockSourceLabel(
                resolveStockDecrementedFrom(this.orderComponent)
            );
        },
        // El backend manda los productos libres aparte de
        // referencesValueWithDiscount; aca se suman los dos tipos de linea.
        productsSubtotal() {
            return [
                ...(this.orderComponent.references || []),
                ...(this.orderComponent.anonymousReferences || [])
            ].reduce(
                (total, line) =>
                    total + resolveLineSalePrice(line) * line.quantity,
                0
            );
        },
        isQuote() {
            return this.orderComponent.deliveryStatus === ordersStatuses.quote;
        },
        orderMessage() {
            if (this.orderComponent.deliveryStatus === ordersStatuses.quote) {
                return "Cotización";
            }
            if (
                this.orderComponent.deliveryStatus === ordersStatuses.completed
            ) {
                return "Venta";
            }
            return "Orden";
        },
        // pedido-domicilio-portal (design.md D6): entrega y envío solo se
        // editan en pedidos creados desde el portal.
        isPortalOrder() {
            return this.orderComponent.origin === "portal";
        },
        canEditDeliveryPrice() {
            return (
                this.isPortalOrder &&
                this.orderComponent.deliveryOption === "home"
            );
        },
        hasSalePriceErrors() {
            return this.orderComponent.references.some(
                (item) =>
                    !!validateLineSalePrice({
                        salePrice: resolveLineSalePrice(item),
                        priceOffer: item.priceOffer,
                        allowAboveCatalog: this.isPortalOrder
                    })
            );
        },
        canSeeOrderHistory() {
            return (
                this.$ability.hasPermission("order:GetHistory") &&
                Array.isArray(this.orderComponent.metadata)
            );
        }
    },
    watch: {
        orderComponent(value) {
            this.savedPaymentStatus = value ? value.paymentStatus : null;
            this.savedDeliveryOption = value ? value.deliveryOption : null;
        },
        enabledUpdate(value) {
            this.enabledScanner = value;
            this.SET_EDIT_ORDER(value);
        },
        "$route.params.id"(newId, oldId) {
            if (!newId || newId === oldId) return;
            this.id = parseInt(newId);
            if (this.isMerchantOrder) {
                this.getReducedBaseItem();
            } else {
                this.getBaseItem();
            }
        }
    },
    async mounted() {
        this.isMerchantOrder = this.$route.name === "OrdersReducedDetail";
        this.homeUrl = "/app/orders";
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (this.isMerchantOrder) {
            if (!(await verifyPagePermission("order:GetOwn", this.homeUrl)))
                return;
            const { id, merchantId, merchantType } = this.$route.params;

            if (!id) {
                await this.requestOrderId();
                return;
            }

            this.id = parseInt(id);
            if (merchantId && merchantType) {
                this.merchant = { merchantId, merchantType };
            } else {
                this.$router.push(this.homeUrl);
            }
            this.loadInventoryMode();
            this.getReducedBaseItem();
            return;
        }
        if (!(await verifyPagePermission("order:Get", this.homeUrl))) return;
        const { id } = this.$route.params;

        if (!id) {
            await this.requestOrderId();
            return;
        }

        this.id = parseInt(id);
        this.loadInventoryMode();
        this.getBaseItem();
    },
    methods: {
        ...mapMutations("orders", ["SET_EDIT_ORDER"]),
        ...mapActions("orders", [
            "getOrderOwnById",
            "getOrderById",
            "updateOrder",
            "suggestOrderDeliveryPrice",
            "deleteOrder",
            "completeOrder",
            "assignOrder",
            "nextOrderStatusesOrder"
        ]),
        ...mapActions("tenants", [
            "getCachedTenantBrandingSettings",
            "getTenantInventorySettings"
        ]),
        async loadInventoryMode() {
            if (!this.$ability.hasPermission("tenant:GetInventorySettings"))
                return;
            try {
                const data = await this.getTenantInventorySettings();
                this.inventoryMode = data.inventoryMode || null;
            } catch {
                this.inventoryMode = null;
            }
        },
        async requestOrderId() {
            this.activeTab = "";
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: "Buscar orden",
                text: "Por favor ingresa el ID de la orden que deseas consultar",
                icon: "question",
                input: "number",
                inputPlaceholder: "Ingresa el ID de la orden",
                inputAttributes: {
                    min: 1
                },
                showCancelButton: true,
                confirmButtonColor: "#02672D",
                cancelButtonColor: "#d33",
                confirmButtonText: "Buscar",
                cancelButtonText: "Cancelar"
            });

            if (dialogResult.isConfirmed && dialogResult.value) {
                this.isLoading = true;
                this.$loading.show();

                try {
                    this.id = parseInt(dialogResult.value);

                    if (this.isMerchantOrder) {
                        this.orderComponent = await this.getOrderOwnById({
                            id: this.id,
                            ...this.merchant
                        });
                    } else {
                        this.orderComponent = await this.getOrderById({
                            id: this.id
                        });
                    }

                    this.hasLoadedBase = true;
                    this.activeTab = "home";
                    this.isLoading = false;
                    this.$loading.hide();
                } catch (error) {
                    this.isLoading = false;
                    this.$loading.hide();
                    this.$loading.hide();
                    this.isLoading = false;

                    await this.$swal.fire({
                        background: this.backgroundColor,
                        title: "Orden no encontrada",
                        text: `No se encontró la orden con ID ${dialogResult.value}. Por favor intenta nuevamente.`,
                        icon: "error",
                        confirmButtonColor: "#02672D"
                    });

                    await this.requestOrderId();
                    return;
                }
            } else {
                this.$router.push(this.homeUrl);
            }
        },
        async getReducedBaseItem() {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.orderComponent = await this.getOrderOwnById({
                    id: this.id,
                    ...this.merchant
                });
                this.hasLoadedBase = true;
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });

                if (error.statusCode === 404) {
                    this.$router.push(this.homeUrl);
                }
            }
        },
        async getBaseItem() {
            this.isLoading = true;
            this.$loading.show();
            try {
                this.orderComponent = await this.getOrderById({ id: this.id });
                this.hasLoadedBase = true;
                this.isLoading = false;
                this.$loading.hide();
            } catch (error) {
                this.isLoading = false;
                this.$loading.hide();
                this.isLoading = false;
                await this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                if (error.statusCode === 404) {
                    this.$router.push(this.homeUrl);
                }
            }
        },
        async verifyUpdateOrderDeliveryInfo() {
            if (
                !this.changeValidators.observation &&
                !this.changeValidators.customerNote &&
                !this.changeValidators.deliveryStatus &&
                !this.changeValidators.deliveryAt &&
                !this.changeValidators.deliveryOption
            ) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "info",
                    title: "Sin cambios detectados",
                    text: "No has realizado ningún cambio en las opciones de entrega."
                });
                return;
            }

            if (
                this.changeValidators.deliveryOption &&
                this.orderComponent.deliveryOption === "home"
            ) {
                if (!this.orderComponent.customer) {
                    this.revertDeliveryOption();
                    this.$swal.fire({
                        background: this.backgroundColor,
                        icon: "info",
                        title: "Asigna un cliente primero",
                        text: "Un pedido a domicilio necesita un cliente para guardar la dirección de entrega."
                    });
                    return;
                }
                this.homeDeliveryLocation = null;
                this.homeDeliveryPrice = this.orderComponent.deliveryPrice || 0;
                this.homeDeliverySaved = false;
                this.isOpenModalSelectAddress = true;
                return;
            }
            const dataToUpdate = {
                id: this.orderComponent.id,
                ...{
                    ...(this.changeValidators.deliveryStatus
                        ? { deliveryStatus: this.orderComponent.deliveryStatus }
                        : null)
                },
                ...{
                    ...(this.changeValidators.deliveryOption
                        ? { deliveryOption: this.orderComponent.deliveryOption }
                        : null)
                },
                ...{
                    ...(this.changeValidators.observation
                        ? { observation: this.orderComponent.observation }
                        : null)
                },
                ...{
                    ...(this.changeValidators.customerNote
                        ? { customerNote: this.orderComponent.customerNote }
                        : null)
                },
                ...{
                    ...(this.changeValidators.deliveryAt
                        ? {
                              deliveryAt: DateTime.fromJSDate(
                                  new Date(this.orderComponent.deliveryAt)
                              )
                                  .toUTC()
                                  .toFormat("yyyy-MM-dd")
                          }
                        : null)
                }
            };
            this.updateOrderDeliveryInfo(dataToUpdate);
        },
        async updateOrderDeliveryInfo(dataToUpdate) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const resultOrderUpdate = await this.updateOrder(dataToUpdate);
                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultOrderUpdate
                };
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.resetValidators();
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateOrderCustomer(customer) {
            this.isOpenModalCustomers = false;
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: `Deseas asignar orden #${this.orderComponent.id}`,
                text: `Vas a asignar la orden a ${customer.firstName} ${customer.lastName}`,
                icon: "info",
                showDenyButton: true,
                showCloseButton: true,
                confirmButtonColor: "#02672D"
            });

            if (!dialogResult.isConfirmed) {
                return;
            }
            this.orderComponent.customer = customer;
            this.isLoading = true;
            this.$loading.show();
            const dataToUpdate = {
                id: this.orderComponent.id,
                customerId: customer.id
            };

            try {
                const resultOrderUpdate = await this.updateOrder(dataToUpdate);
                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultOrderUpdate
                };
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            } finally {
                this.$loading.hide();
                this.isLoading = false;
                this.resetValidators();
            }
        },
        async confirmWebhookPaymentOverride() {
            const savedOrder = {
                ...this.orderComponent,
                paymentStatus: this.savedPaymentStatus
            };
            if (
                this.orderComponent.paymentStatus === this.savedPaymentStatus ||
                !isPaymentConfirmedByWebhook(savedOrder)
            ) {
                return true;
            }

            const confirmedAt = getWebhookConfirmationDate(savedOrder);
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                icon: "warning",
                title: "Pago confirmado por la pasarela",
                text: `Este pago lo confirmó la pasarela${
                    confirmedAt ? ` el ${dateFilter(confirmedAt)}` : ""
                }. ¿Seguro que quieres cambiarlo?`,
                showCancelButton: true,
                confirmButtonColor: "#02672D",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, cambiarlo",
                cancelButtonText: "Cancelar"
            });
            return dialogResult.isConfirmed;
        },
        async completeOrderPayment() {
            this.orderComponent.paymentStatus = paymentStatuses.approved;
            this.changeValidators.paymentStatus = true;
            await this.updateOrderPaymentInfo(false);
        },
        async updateOrderPaymentInfo(checkUpdates = true) {
            if (
                checkUpdates &&
                !this.changeValidators.valuePaid &&
                !this.changeValidators.paymentMethod &&
                !this.changeValidators.paymentStatus &&
                !this.changeValidators.deliveryPrice
            ) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "info",
                    title: "Sin cambios detectados",
                    text: "No has realizado ningún cambio en la información de pago."
                });
                return;
            }

            if (!(await this.confirmWebhookPaymentOverride())) {
                this.orderComponent.paymentStatus = this.savedPaymentStatus;
                this.changeValidators.paymentStatus = false;
                return;
            }

            this.isLoading = true;
            this.$loading.show();
            const dataToUpdate = {
                id: this.orderComponent.id,
                ...{
                    ...(this.changeValidators.valuePaid
                        ? { valuePaid: this.orderComponent.valuePaid }
                        : null)
                },
                ...{
                    ...(this.changeValidators.paymentStatus
                        ? { paymentStatus: this.orderComponent.paymentStatus }
                        : null)
                },
                ...{
                    ...(this.changeValidators.paymentMethod
                        ? { paymentMethod: this.orderComponent.paymentMethod }
                        : null)
                },
                ...{
                    ...(this.changeValidators.deliveryPrice
                        ? { deliveryPrice: this.orderComponent.deliveryPrice }
                        : null)
                }
            };

            try {
                const resultOrderUpdate = await this.updateOrder(dataToUpdate);
                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultOrderUpdate
                };
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            } finally {
                this.$loading.hide();
                this.isLoading = false;
                this.resetValidators();
            }
        },
        async updateReferences() {
            if (
                !this.changeValidators.references &&
                !this.changeValidators.anonymousReferences
            ) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "info",
                    title: "Sin cambios detectados",
                    text: "No has realizado ningún cambio en las referencias."
                });
                return;
            }

            this.isLoading = true;
            let alterInventory = false;
            if (
                !this.orderComponent.stockDecremented &&
                this.affectsInventory
            ) {
                const dialogResult = await this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Deseas afectar inventario",
                    text: "Puedes verificar si hay suficiente stock para las nuevas referencias que agregaste o las referencias que cambiaste la cantidad. En caso de disminuir cantidad puedes la diferencia regresa al inventario.",
                    icon: "info",
                    showDenyButton: true,
                    showCloseButton: true,
                    confirmButtonColor: "#02672D",
                    denyButtonColor: "#253C99",
                    confirmButtonText: "Si Afectar inventario",
                    denyButtonText: "Solo Actualizar"
                });
                if (dialogResult.isConfirmed) {
                    alterInventory = true;
                } else if (dialogResult.isDenied) {
                    alterInventory = false;
                } else {
                    return;
                }
            }

            this.$loading.show();
            const dataToUpdate = {
                alterInventory,
                id: this.orderComponent.id,
                ...{
                    ...(this.changeValidators.references
                        ? {
                              references: this.orderComponent.references.map(
                                  (item) => ({
                                      id: item.id,
                                      quantity: item.quantity,
                                      salePrice: resolveLineSalePrice(item)
                                  })
                              )
                          }
                        : null)
                },
                ...{
                    ...(this.changeValidators.anonymousReferences
                        ? {
                              anonymousReferences:
                                  this.orderComponent.anonymousReferences.map(
                                      (item) => ({
                                          priceOffer: item.priceOffer,
                                          quantity: item.quantity,
                                          appliedDiscountPerReference:
                                              item.appliedDiscountPerReference,
                                          product: item.product
                                      })
                                  )
                          }
                        : null)
                }
            };

            try {
                const resultOrderUpdate = await this.updateOrder(dataToUpdate);
                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultOrderUpdate
                };
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.resetValidators();
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async updateMerchantInfo() {
            if (!this.changeValidators.stockDecremented) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "info",
                    title: "Sin cambios detectados",
                    text: "No has realizado ningún cambio en la información del proveedor."
                });
                return;
            }

            const dataToUpdate = {
                id: this.orderComponent.id,
                ...{
                    ...(this.changeValidators.stockDecremented
                        ? {
                              stockDecremented:
                                  this.orderComponent.stockDecremented
                          }
                        : null)
                }
            };
            this.isLoading = true;
            this.$loading.show();
            try {
                const resultOrderUpdate = await this.updateOrder(dataToUpdate);
                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultOrderUpdate
                };
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.resetValidators();
                this.$loading.hide();
                this.isLoading = false;
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
                this.orderComponent = {
                    ...this.orderComponent,
                    stockDecremented: Boolean(this.order.stockDecremented)
                };
            }
        },
        async deleteOrderComponent() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                title: `Vas a eliminar la orden ${this.id}`,
                text: "Las ordenes solo deben eliminarse en caso de que se esten haciendo pruebas, eres consiente de lo que estas haciendo ?. Escribe 'Si' para eliminar",
                icon: "error",
                input: "text",
                confirmButtonColor: "#ee3f59",
                cancelButtonColor: "#253C99",
                showCancelButton: true
            });
            if (
                dialogResult.isConfirmed &&
                validateConfirmationMessage(dialogResult.value)
            ) {
                try {
                    await this.deleteOrder({ id: this.id });
                    this.$toast.success({
                        title: `Orden # ${this.id} eliminada`
                    });
                    this.$router.push(this.homeUrl);
                } catch (error) {
                    this.$swal.fire({
                        background: this.backgroundColor,
                        title: error.title,
                        text: error.message,
                        icon: error.icon
                    });
                }
            }
        },
        async completeOrderComponent() {
            let verifyAndDecreaseInventory = true;
            const stockAlreadyDecremented =
                this.orderComponent.stockDecremented;
            const hasMerchant = this.affectsInventory;

            if (!hasMerchant) {
                verifyAndDecreaseInventory = false;
            } else if (!stockAlreadyDecremented) {
                const stockDecision = await this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "warning",
                    title: "Inventario pendiente",
                    html: `
                <div class="text-left space-y-3 text-sm">
                    <p>
                        Esta orden <strong class="text-theme-danger">aún no ha descontado productos del inventario</strong>.
                    </p>

                    <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                        <p class="font-semibold mb-1 text-black">¿Qué significa esto?</p>
                        <ul class="list-disc list-inside space-y-1 text-black">
                            <li>Si validas el inventario, se descontarán las cantidades.</li>
                            <li>Si no lo validas, la orden se cerrará <strong>sin afectar el stock</strong>.</li>
                        </ul>
                    </div>
                </div>
            `,
                    showDenyButton: true,
                    confirmButtonColor: "#02913f",
                    denyButtonColor: "#B38F00",
                    confirmButtonText: "Validar y descontar stock",
                    denyButtonText: "Completar sin stock",
                    showCloseButton: true
                });
                if (stockDecision.isDismissed) return;

                if (stockDecision.isDenied) {
                    // User chose the alternative action: continue but do NOT decrease inventory
                    verifyAndDecreaseInventory = false;
                }
            }

            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                icon: "info",
                title: `Completar orden #${this.id}`,
                html: `
            <div class="text-left space-y-4 text-sm">
                <p class="font-medium">
                    Al completar esta orden se realizarán las siguientes acciones:
                </p>

                <ul class="space-y-2">
                    <li class="flex items-start gap-2">
                        <span>📦</span>
                        <span>
                            Estado de entrega:
                            <strong class="text-theme-success">Completado</strong>
                        </span>
                    </li>

                    <li class="flex items-start gap-2">
                        <span>💰</span>
                        <span>
                            Estado de pago:
                            <strong class="text-theme-success">Completado</strong>
                        </span>
                    </li>

                    <li class="flex items-start gap-2">
                        <span>💵</span>
                        <span>
                            Valor pagado se ajusta al
                            <strong>total de la orden</strong>
                        </span>
                    </li>

                    <li class="flex items-start gap-2">
                        <span>📦</span>
                        <span>
                            Inventario:
                            ${
                                !hasMerchant
                                    ? `<strong class="text-theme-muted">${this.noInventoryReason}</strong>`
                                    : stockAlreadyDecremented
                                    ? `<strong class="text-theme-success">Stock ya descontado previamente</strong>`
                                    : verifyAndDecreaseInventory
                                    ? `<strong class="text-theme-warning">Se validará y descontará el stock</strong>`
                                    : `<strong class="text-theme-muted">No se afectará el inventario</strong>`
                            }
                        </span>
                    </li>
                </ul>

                <div class="bg-theme-hover border border-theme-border rounded-lg p-3 text-xs text-theme-base">
                    Esta acción es <strong>definitiva</strong> y no podrá deshacerse.
                </div>
            </div>
        `,
                showCancelButton: true,
                confirmButtonColor: "#02913f",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, completar orden",
                cancelButtonText: "Cancelar",
                showCloseButton: true
            });

            if (!dialogResult.isConfirmed) return;

            this.$loading.show();

            try {
                const resultComplete = await this.completeOrder({
                    id: this.id,
                    verifyAndDecreaseInventory
                });

                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultComplete
                };

                this.$loading.hide();
                this.$sound.play();

                await this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "success",
                    title: "Orden completada",
                    text: "Todos los cambios fueron aplicados correctamente.",
                    timer: 2500,
                    showConfirmButton: false
                });

                this.resetValidators();
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async nextOrderStatusesOrderComponent() {
            const currentStatus = this.orderComponent.deliveryStatus;
            const nextStatus = nextOrderStatuses[currentStatus];
            const currentStatusMessage = ordersStatusesCodes[currentStatus];

            if (!nextStatus) {
                this.$swal.fire({
                    background: this.backgroundColor,
                    icon: "warning",
                    title: "No se puede avanzar",
                    text: `La orden con estado "${currentStatusMessage}" no puede avanzar a un siguiente estado.`
                });
                return;
            }

            const nextStatusMessage = ordersStatusesCodes[nextStatus];

            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                icon: "question",
                title: `Actualizar estado de la orden ${this.id}`,
                html: `<div class="text-left">
                    <p><strong>Estado actual:</strong> ${currentStatusMessage}</p>
                    <p><strong>Siguiente estado:</strong> ${nextStatusMessage}</p>
                    <br/>
                    <p>¿Deseas continuar con esta actualización?</p>
                </div>`,
                showCancelButton: true,
                confirmButtonColor: "#02913f",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Si, actualizar",
                cancelButtonText: "Cancelar"
            });
            if (!dialogResult.isConfirmed) return;

            this.$loading.show();

            try {
                await this.nextOrderStatusesOrder({
                    id: this.id
                });

                this.orderComponent = {
                    ...this.orderComponent,
                    deliveryStatus: nextStatus,
                    deliveryStatusMessage: nextStatusMessage
                };

                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    html: `<div class="text-left">
                        <p><strong>Estado anterior:</strong> ${currentStatusMessage}</p>
                        <p><strong>Estado nuevo:</strong> ${nextStatusMessage}</p>
                    </div>`,
                    icon: "success",
                    showCloseButton: true,
                    timer: 5000
                });
                this.$loading.hide();
                this.resetValidators();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async assignOrderComponent() {
            const dialogResult = await this.$swal.fire({
                background: this.backgroundColor,
                icon: "info",
                title: `Vas a asignar la orden ${this.id}`,
                text: `Vas a asignar a tienda${this.selectedMerchant.name}. Desear validar el inventario del tiendacon las referencias de la orden ?`,
                showDenyButton: true,
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonColor: "#02672D",
                denyButtonColor: "#253C99",
                cancelButtonColor: "#EA5455",
                confirmButtonText: "Si",
                denyButtonText: "No",
                cancelButtonText: "Cancelar"
            });
            if (dialogResult.isDismissed) return;

            this.$loading.show();

            try {
                const resultAsign = await this.assignOrder({
                    id: this.id,
                    merchantType: this.selectedMerchant.merchantType,
                    merchantId: this.selectedMerchant.merchantId,
                    validateStock: dialogResult.isConfirmed
                });
                this.orderComponent = {
                    ...this.orderComponent,
                    ...resultAsign
                };
                this.$sound.play();
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Actualización exitosa",
                    icon: "success",
                    showCloseButton: true,
                    timer: 3000
                });
                this.$loading.hide();
                this.resetValidators();
            } catch (error) {
                this.$loading.hide();
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        openAssignCustomer() {
            this.isOpenModalCustomers = true;
        },

        dateDisabled(ymd, date) {
            // Disable weekends (Sunday = `0`, Saturday = `6`) and
            // disable days that fall on the 13th of the month
            const weekday = date.getDay();
            //const day = date.getDate();
            // Return `true` if the date should be disabled
            return [0, 6].includes(weekday);
        },
        resetValidators() {
            this.changeValidators = {
                valuePaid: false,
                observation: false,
                customerNote: false,
                paymentStatus: false,
                deliveryOption: false,
                deliveryStatus: false,
                paymentMethod: false,
                reference: false,
                stockDecremented: false,
                deliveryAt: false,
                customer: false,
                deliveryPrice: false
            };
        },
        addAnonymousReference({
            appliedDiscountPerReference,
            priceOffer,
            product,
            quantity,
            size
        }) {
            this.orderComponent.anonymousReferences = [
                ...this.orderComponent.anonymousReferences,
                {
                    anonymousId: this.orderComponent.anonymousReferences.length,
                    priceOffer,
                    quantity,
                    size,
                    product,
                    appliedDiscountPerReference:
                        appliedDiscountPerReference || 0
                }
            ];
            this.changeValidators.anonymousReferences = true;
            this.calculateTotals();
        },
        changeQuantityAnonymousReference({
            anonymousId,
            appliedDiscountPerReference,
            priceOffer,
            product,
            quantity
        }) {
            this.onBlurSomeInput();
            const index = this.orderComponent.anonymousReferences.findIndex(
                (item) => item.anonymousId === anonymousId
            );
            const anonymousReferences = [
                ...this.orderComponent.anonymousReferences
            ];
            anonymousReferences[index] = {
                ...anonymousReferences[index],
                quantity,
                appliedDiscountPerReference,
                product,
                priceOffer
            };
            this.orderComponent.anonymousReferences = [...anonymousReferences];
            this.changeValidators.anonymousReferences = true;
            this.calculateTotals();
        },
        removeAnonymousReference({ anonymousId }) {
            const index = this.orderComponent.anonymousReferences.findIndex(
                (item) => item.anonymousId === anonymousId
            );
            let anonymousReferences = [
                ...this.orderComponent.anonymousReferences
            ];
            anonymousReferences.splice(index, 1);
            this.orderComponent.anonymousReferences = [...anonymousReferences];
            this.changeValidators.anonymousReferences = true;
            this.calculateTotals();
        },
        validatePushReferences(reference) {
            const index = this.orderComponent.references.findIndex(
                (item) => item.id === reference.id
            );

            if (index === -1) {
                this.orderComponent.references.unshift({
                    ...reference,
                    quantity: 1
                });
            } else {
                let references = [...this.orderComponent.references];
                references[index] = {
                    ...references[index],
                    quantity: references[index].quantity + 1
                };
                this.orderComponent.references = [...references];
            }
            this.changeValidators.references = true;
            this.calculateTotals();
        },
        changeQuantityReference({
            appliedDiscountPerReference,
            id,
            quantity,
            salePrice
        }) {
            this.onBlurSomeInput();
            const index = this.orderComponent.references.findIndex(
                (item) => item.id == id
            );
            let references = [...this.orderComponent.references];
            references[index] = {
                ...references[index],
                quantity,
                appliedDiscountPerReference,
                ...(salePrice !== undefined ? { salePrice } : {})
            };
            this.orderComponent.references = [...references];
            this.changeValidators.references = true;
            this.calculateTotals();
        },
        removeReference({ id }) {
            if (this.orderComponent.references.length === 1) {
                return this.$swal.fire({
                    background: this.backgroundColor,
                    title: "Operación NO permitida",
                    text: "La orden debe quedar como mínimo con un 1 referencia",
                    icon: "info"
                });
            }
            const index = this.orderComponent.references.findIndex(
                (item) => item.id === id
            );
            let references = [...this.orderComponent.references];
            references.splice(index, 1);
            this.orderComponent.references = [...references];
            this.changeValidators.references = true;
            this.calculateTotals();
        },
        calculateTotals() {
            this.orderComponent.referencesValueWithDiscount = [
                ...this.orderComponent.references,
                ...this.orderComponent.anonymousReferences
            ].reduce((a, b) => a + resolveLineSalePrice(b) * b.quantity, 0);
            this.orderComponent.total =
                this.orderComponent.referencesValueWithDiscount +
                (this.orderComponent.deliveryPrice || 0) +
                (this.orderComponent.paymentPrice || 0) -
                this.orderComponent.totalDiscountApplied;
        },
        async resolveTenantLogo(field) {
            try {
                const branding = await this.getCachedTenantBrandingSettings();
                const remoteUrl = branding?.[field];
                if (remoteUrl && (await verifyImageLoads(remoteUrl))) {
                    return remoteUrl;
                }
                return STATIC_ORDER_LOGO_PATH;
            } catch {
                return STATIC_ORDER_LOGO_PATH;
            }
        },
        async resolveTenantName() {
            try {
                const branding = await this.getCachedTenantBrandingSettings();
                return branding?.name || "";
            } catch {
                return "";
            }
        },
        async generateOrderComponentPDF() {
            const logoUrl = await this.resolveTenantLogo("logoHorizontalUrl");
            const tenantName = await this.resolveTenantName();
            const {
                anonymousReferences,
                createdAt,
                customer,
                customerNote,
                deliveryAt,
                deliveryPrice,
                id,
                location,
                paymentMethod,
                paymentStatus,
                pickupMerchant,
                references,
                referencesValueWithDiscount,
                supplyMerchant,
                total,
                uuid,
                valuePaid
            } = this.orderComponent;
            const referencesMapped = [...references, ...anonymousReferences]
                .filter((item) => item.quantity)
                .map((item) => ({
                    ...item,
                    priceApplied: this.$options.filters.currency(
                        resolveLineSalePrice(item)
                    ),
                    totalPriceApplied: this.$options.filters.currency(
                        resolveLineSalePrice(item) * item.quantity
                    )
                }));
            const paymentMethodMessage = paymentMethodsCodes[paymentMethod];
            const orderFormated = {
                id,
                uuid,
                customer,
                customerNote,
                location,
                logoUrl,
                pickupMerchant,
                supplyMerchant,
                tenantName,
                orderMessage: this.orderMessage,
                deliveryAt: this.$options.filters.date(deliveryAt),
                createdAt: this.$options.filters.date(createdAt),
                valuePaid: this.$options.filters.currency(valuePaid),
                hasBalance: valuePaid > 0 && valuePaid < total,
                hasDeliveryPrice: deliveryPrice !== 0,
                deliveryPrice: this.$options.filters.currency(deliveryPrice),
                referencesValueWithDiscount: this.$options.filters.currency(
                    referencesValueWithDiscount
                ),
                total: this.$options.filters.currency(total),
                balance: this.$options.filters.currency(total - valuePaid),
                paymentMethodMessage,
                approvedPaymentMethodMessage:
                    paymentStatus === paymentStatuses.approved
                        ? paymentMethodMessage
                        : "",
                references: referencesMapped
            };
            await generateOrderPDF(orderFormated);
        },
        onFocusSomeInput() {
            this.enabledScanner = false;
        },
        onBlurSomeInput() {
            this.enabledScanner = true;
        },
        reloadPage() {
            this.$router.go(this.$router.currentRoute);
        },
        revertDeliveryOption() {
            this.orderComponent.deliveryOption = this.savedDeliveryOption;
            this.changeValidators.deliveryOption = false;
        },
        closeSelectAddressModal() {
            if (!this.homeDeliverySaved) {
                this.revertDeliveryOption();
            }
        },
        async onHomeDeliveryLocationChange(value) {
            this.homeDeliveryLocation = value;
            if (!value) return;
            try {
                const { deliveryPrice } = await this.suggestOrderDeliveryPrice({
                    cityCode: value.cityCode,
                    references: this.orderComponent.references.map((item) => ({
                        id: item.id,
                        quantity: item.quantity,
                        salePrice: resolveLineSalePrice(item)
                    })),
                    anonymousReferences:
                        this.orderComponent.anonymousReferences.map((item) => ({
                            priceOffer: item.priceOffer,
                            quantity: item.quantity
                        }))
                });
                this.homeDeliveryPrice = deliveryPrice;
            } catch {
                // sin sugerido: el costo de envío se escribe a mano
            }
        },
        async saveHomeDelivery() {
            const { customerLocationId, location } = this.homeDeliveryLocation;
            this.homeDeliverySaved = true;
            this.isOpenModalSelectAddress = false;
            await this.updateOrderDeliveryInfo({
                id: this.orderComponent.id,
                deliveryOption: "home",
                deliveryPrice: this.homeDeliveryPrice,
                ...(customerLocationId ? { customerLocationId } : { location })
            });
            await (this.isMerchantOrder
                ? this.getReducedBaseItem()
                : this.getBaseItem());
        },
        goToRefactor() {
            this.showOptions = false;
            window
                .open(
                    `/app/orders/refactor/${this.orderComponent.id}`,
                    "_blank"
                )
                .focus();
        }
    }
};
</script>
